import { Component } from '@angular/core';
import { ThemeService } from '@infra/theme/theme.service';
import { BaseComponent } from '@app/common/modules/base/base.component';
import { LogoutController } from '@modules/auth/controllers';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
})
export class LogoutComponent extends BaseComponent {
  public isSubmitting = false;

  constructor(
    public logoutController: LogoutController,
  ) {
    super('Logout - Portal do Cliente');
    this.logout();
  }

  public logout(): void {
    this.logoutController.logout().subscribe();
  }
}
